import React, { useEffect, useState } from 'react';
import { SimpleGrid, Icon } from '@chakra-ui/react';
import { FaClipboardList, FaUsers, FaBoxes } from 'react-icons/fa';
import PageShell from './ui/PageShell';
import StatTile from './ui/StatTile';
import { getComplaints, getTechnicians, getInventory } from '../Utilities/networks';

const Dashboard = () => {
  const [stats, setStats] = useState({ complaints: 0, technicians: 0, inventory: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [c, t, i] = await Promise.all([
          getComplaints().catch(() => null),
          getTechnicians().catch(() => null),
          getInventory().catch(() => null),
        ]);
        setStats({
          complaints: c?.data?.data?.length ?? 0,
          technicians: t?.data?.data?.length ?? 0,
          inventory: i?.data?.data?.length ?? 0,
        });
      } catch {
        /* keep zeros */
      }
    };
    load();
  }, []);

  return (
    <PageShell
      title="Dashboard"
      subtitle="Overview of your Terracool operations"
    >
      <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={5}>
        <StatTile
          label="Open Complaints"
          value={stats.complaints}
          accent="brand.500"
          icon={<Icon as={FaClipboardList} />}
        />
        <StatTile
          label="Technicians"
          value={stats.technicians}
          accent="accent.500"
          icon={<Icon as={FaUsers} />}
        />
        <StatTile
          label="Inventory Items"
          value={stats.inventory}
          accent="brand.700"
          icon={<Icon as={FaBoxes} />}
        />
      </SimpleGrid>
    </PageShell>
  );
};

export default Dashboard;
